import React, { useEffect, useMemo, useState } from 'react'
import { Card, Grid, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import axios from 'axios.js'

const useStyles = makeStyles(() => ({
    card: {
        maxWidth: 980,
        borderRadius: 16,
        margin: '1rem',
        boxShadow: '0px 0px 13px 3px #eeeeee',
    },
    content: {
        lineHeight: 1.5,
        color: '#334155',
        '& p': {
            margin: '0 0 10px',
        },
        '& ul, & ol': {
            margin: '0 0 10px 20px',
        },
    },
}))

const defaultLegal = {
    legal_terms_title: 'Пользовательское соглашение',
    legal_terms_text: '',
    legal_privacy_title: 'Политика конфиденциальности',
    legal_privacy_text: '',
    legal_offer_title: 'Публичная оферта',
    legal_offer_text: '',
    legal_marketing_title: 'Согласие на получение рекламных сообщений',
    legal_marketing_text: '',
}

const LegalDocumentPage = () => {
    const classes = useStyles()
    const location = useLocation()
    const [data, setData] = useState(defaultLegal)
    const [error, setError] = useState('')

    useEffect(() => {
        let mounted = true
        axios.get('/api/auth/legal')
            .then((res) => {
                if (!mounted) return
                const payload = res?.data || {}
                if (payload?.error) {
                    setError(payload?.errorInfo || 'Ошибка загрузки документа')
                    return
                }
                const legal = payload?.data || {}
                setData((prev) => ({ ...prev, ...legal }))
            })
            .catch((e) => {
                if (!mounted) return
                setError(e?.response?.data?.message || e?.message || 'Ошибка загрузки документа')
            })
        return () => { mounted = false }
    }, [])

    const page = useMemo(() => {
        const path = location.pathname || ''
        if (path.includes('/privacy')) return { title: data.legal_privacy_title, text: data.legal_privacy_text }
        if (path.includes('/offer')) return { title: data.legal_offer_title, text: data.legal_offer_text }
        if (path.includes('/marketing')) return { title: data.legal_marketing_title, text: data.legal_marketing_text }
        return { title: data.legal_terms_title, text: data.legal_terms_text }
    }, [location.pathname, data])

    return (
        <div className={clsx('flex justify-center items-center min-h-full-screen')}>
            <Card className={classes.card}>
                <Grid container>
                    <Grid item xs={12}>
                        <div className="p-8 h-full relative">
                            <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 12 }}>
                                {page.title}
                            </Typography>
                            {!!error && <Typography style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</Typography>}
                            {!error && (
                                page.text
                                    ? <div className={classes.content} dangerouslySetInnerHTML={{ __html: page.text }} />
                                    : <Typography className={classes.content}>Документ пока не заполнен.</Typography>
                            )}
                            <div style={{ marginTop: 16 }}>
                                <Link to="/session/signup">
                                    <Button variant="outlined" color="primary">Вернуться к регистрации</Button>
                                </Link>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </div>
    )
}

export default LegalDocumentPage
